import StoreInfoService from '../../services/storeInfo/storeInfoService';

const getStoreInfo: (storeUuid: string, mode?: string | null) => any = async (
  storeUuid,
  mode
) => {
  try {
    const res = await StoreInfoService.getStoreInfo(storeUuid, mode);
    return await Promise.resolve(res.data);
  } catch (err) {
    console.log('axios error', err);
    throw err;
  }
};

const StoreInfoAction = {
  getStoreInfo,
};

export default StoreInfoAction;
